export { default } from 'features/account/routes/account-order-detail-route';
